



















import { Component, Vue, Prop} from 'vue-property-decorator';
import { vxm } from './../store.vuex';
import { GenericLookup } from '../models/utility/lookup';

@Component({
    name: 'SelectOptions',
    components: {
    }
})
export default class SelectOptions extends Vue {

  @Prop() private genericLookup: GenericLookup[] = [];
  private selectedOption: GenericLookup = new GenericLookup();

  public GenLookup(): GenericLookup[] {
    console.log(this.genericLookup);
    return JSON.parse(JSON.stringify(this.genericLookup));
  }

  select(idx: any) {
    this.selectedOption = this.genericLookup[idx];
  }
}

